import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import fetchWrapper from "../utils/httpClient";
import { API_GET_PRODUCT, API_UPDATE_PRODUCT } from "../utils/apis";
import { API_STATE } from "../utils/constant";

// Asynchronous thunk for fetching resources by content type
export const fetchProduct = createAsyncThunk(
  "product/fetchProduct",
  async ({ productId, language }) => {
    try {
      const response = await fetchWrapper.get(
        `${API_GET_PRODUCT}/${productId}/${language}`
      );

      const contentData = response.resdata.contentData || {};
      return {
        ...contentData,
        region: response.resdata.region,
        language: response.resdata.language,
        languages: response.resdata.languages || [],
        uuid: response.resdata.uuid
      };
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

export const updateProduct = createAsyncThunk(
  "product/updateProduct",
  async ({ uuid, language, payload }) => {
    try {
      const response = await fetchWrapper.put(
        `${API_UPDATE_PRODUCT}/${uuid}/${language}`,
        payload
      );
      return response;
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const initialProduct = {
  basicInfo: {
    sku: "",
    day: "",
    name: "",
    des: "",
    price: "",
    startDate: "",
    endDate: "",
    promoOnly: false
  },
  region: "SG",
  languages: [],
};

const productSlice = createSlice({
  name: "product",
  initialState: {
    data: null,
    status: API_STATE.IDLE,
    error: null,
  },
  reducers: {
    resetProductValue: (state, action) => {
      const { payload } = action;
      state.data = { ...initialProduct, languages: [payload.language] };
      state.status = API_STATE.SUCCEEDED;
    },
    setValueBasicInfo: (state, action) => {
      const { payload } = action;
      if (state.data?.contentData) {
        state.data.contentData.basicInfo[payload.key] = payload.value;
      } else {
        state.data.basicInfo[payload.key] = payload.value;
      }
    },
    setError: (state, action) => {
      const { payload } = action;
      state.error = { ...payload };
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetch product
      .addCase(fetchProduct.pending, (state) => {
        state.error = null;
        state.status = API_STATE.LOADING;
      })
      .addCase(fetchProduct.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = API_STATE.SUCCEEDED;
      })
      .addCase(fetchProduct.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = API_STATE.FAILED;
      })

      // Handle update product
      .addCase(updateProduct.pending, (state) => {
        state.error = null;
        state.status = API_STATE.LOADING;
      })
      .addCase(updateProduct.fulfilled, (state) => {
        state.status = API_STATE.SUCCEEDED;
      })
      .addCase(updateProduct.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = API_STATE.FAILED;
      });
  },
});

export const {
  resetProductValue,
  setValueBasicInfo,
  setError,
} = productSlice.actions;

export default productSlice.reducer;